import { useState, useEffect } from 'react';
import api from '../../services/api';

export default function Taxas() {
  const [taxas, setTaxas] = useState([]);
  const [filtro, setFiltro] = useState('todos');
  const [busca, setBusca] = useState('');
  const [editando, setEditando] = useState(null);
  const [novo, setNovo] = useState({ nome: '', tipo: 'bairro', valor: '', ativo: 1 });
  const [toast, setToast] = useState('');

  const carregar = async () => {
    try {
      const r = await api.get('/taxas');
      setTaxas(r.data);
    } catch { showToast('❌ Erro ao carregar'); }
  };

  useEffect(() => { carregar(); }, []);

  const showToast = (msg) => {
    setToast(msg);
    setTimeout(() => setToast(''), 2500);
  };

  const salvarNovo = async () => {
    if (!novo.nome || novo.valor === '') return showToast('⚠️ Preencha nome e valor');
    try {
      await api.post('/taxas', { ...novo, valor: parseFloat(novo.valor) });
      setNovo({ nome: '', tipo: 'bairro', valor: '', ativo: 1 });
      showToast('✅ Cadastrado!');
      carregar();
    } catch (e) { showToast(e.response?.data?.error || '❌ Erro'); }
  };

  const salvarEdicao = async () => {
    try {
      await api.put(`/taxas/${editando.id}`, {
        ...editando,
        valor: parseFloat(editando.valor)
      });
      setEditando(null);
      showToast('✅ Atualizado!');
      carregar();
    } catch (e) { showToast(e.response?.data?.error || '❌ Erro'); }
  };

  const remover = async (t) => {
    if (!window.confirm(`Remover "${t.nome}"?`)) return;
    try {
      await api.delete(`/taxas/${t.id}`);
      showToast('🗑️ Removido');
      carregar();
    } catch { showToast('❌ Erro'); }
  };

  const toggleAtivo = async (t) => {
    try {
      await api.put(`/taxas/${t.id}`, { ...t, ativo: t.ativo ? 0 : 1 });
      carregar();
    } catch { showToast('❌ Erro'); }
  };

  const filtradas = taxas.filter(t => {
    if (filtro !== 'todos' && t.tipo !== filtro) return false;
    if (busca && !t.nome.toLowerCase().includes(busca.toLowerCase())) return false;
    return true;
  });

  const bairros = filtradas.filter(t => t.tipo === 'bairro');
  const condos = filtradas.filter(t => t.tipo === 'condominio');

  const inputStyle = {
    background: 'var(--bg4)', border: '1px solid var(--border)',
    color: 'var(--text)', padding: '8px 12px', borderRadius: 8,
    fontSize: 13, fontFamily: 'Nunito, sans-serif', outline: 'none'
  };

  const renderItem = (t) => (
    <div key={t.id} style={{
      background: 'var(--bg3)', border: '1px solid var(--border)',
      borderRadius: 8, padding: 10, marginBottom: 6,
      display: 'flex', alignItems: 'center', gap: 10,
      opacity: t.ativo ? 1 : 0.5
    }}>
      {editando?.id === t.id ? (
        <>
          <input value={editando.nome} onChange={e => setEditando({...editando, nome: e.target.value})}
            style={{...inputStyle, flex: 1}} />
          <select value={editando.tipo} onChange={e => setEditando({...editando, tipo: e.target.value})}
            style={{...inputStyle, width: 120}}>
            <option value="bairro">Bairro</option>
            <option value="condominio">Condomínio</option>
          </select>
          <input type="number" step="0.01" value={editando.valor}
            onChange={e => setEditando({...editando, valor: e.target.value})}
            style={{...inputStyle, width: 90}} />
          <button onClick={salvarEdicao} style={{
            background: '#2ea82e', border: 'none', color: '#fff',
            padding: '8px 14px', borderRadius: 8, cursor: 'pointer', fontWeight: 700
          }}>✓</button>
          <button onClick={() => setEditando(null)} style={{
            background: 'var(--bg4)', border: '1px solid var(--border)', color: 'var(--text2)',
            padding: '8px 12px', borderRadius: 8, cursor: 'pointer'
          }}>✕</button>
        </>
      ) : (
        <>
          <div style={{ flex: 1, fontWeight: 700, fontSize: 13 }}>{t.nome}</div>
          <div style={{ fontWeight: 800, color: 'var(--orange)', fontSize: 14, width: 80, textAlign: 'right' }}>
            R$ {parseFloat(t.valor).toFixed(2).replace('.', ',')}
          </div>
          <button onClick={() => toggleAtivo(t)} title={t.ativo ? 'Desativar' : 'Ativar'}
            style={{
              background: t.ativo ? '#2ea82e' : 'var(--bg4)',
              border: '1px solid ' + (t.ativo ? '#2ea82e' : 'var(--border)'),
              color: t.ativo ? '#fff' : 'var(--text3)',
              padding: '6px 10px', borderRadius: 6, cursor: 'pointer', fontSize: 11
            }}>{t.ativo ? '🟢' : '⚫'}</button>
          <button onClick={() => setEditando({...t})} style={{
            background: 'var(--bg4)', border: '1px solid var(--border)', color: 'var(--text)',
            padding: '6px 10px', borderRadius: 6, cursor: 'pointer', fontSize: 11
          }}>✏️</button>
          <button onClick={() => remover(t)} style={{
            background: 'rgba(230,48,48,.15)', border: '1px solid rgba(230,48,48,.3)',
            color: 'var(--red)', padding: '6px 10px', borderRadius: 6, cursor: 'pointer', fontSize: 11
          }}>🗑️</button>
        </>
      )}
    </div>
  );

  return (
    <div style={{ padding: 16 }}>
      <h2 style={{ margin: '0 0 16px' }}>🛵 Taxas de Entrega</h2>

      {/* CADASTRAR NOVO */}
      <div className="card" style={{ marginBottom: 16 }}>
        <h3 style={{ marginTop: 0, fontSize: 14 }}>➕ Adicionar local</h3>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          <input placeholder="Nome do bairro/condomínio" value={novo.nome}
            onChange={e => setNovo({...novo, nome: e.target.value})}
            style={{...inputStyle, flex: '1 1 200px'}} />
          <select value={novo.tipo} onChange={e => setNovo({...novo, tipo: e.target.value})}
            style={{...inputStyle, width: 140}}>
            <option value="bairro">Bairro</option>
            <option value="condominio">Condomínio</option>
          </select>
          <input type="number" step="0.01" placeholder="Taxa R$" value={novo.valor}
            onChange={e => setNovo({...novo, valor: e.target.value})}
            style={{...inputStyle, width: 110}} />
          <button onClick={salvarNovo} style={{
            background: 'linear-gradient(90deg,var(--red),var(--orange))',
            border: 'none', color: '#fff', padding: '8px 18px',
            borderRadius: 8, cursor: 'pointer', fontWeight: 800
          }}>Adicionar</button>
        </div>
      </div>

      {/* FILTROS */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 12, flexWrap: 'wrap' }}>
        <input placeholder="🔍 Buscar..." value={busca} onChange={e => setBusca(e.target.value)}
          style={{...inputStyle, flex: 1, minWidth: 180}} />
        {['todos','bairro','condominio'].map(f => (
          <button key={f} onClick={() => setFiltro(f)} style={{
            background: filtro === f ? 'var(--orange)' : 'var(--bg4)',
            border: '1px solid ' + (filtro === f ? 'var(--orange)' : 'var(--border)'),
            color: filtro === f ? '#fff' : 'var(--text2)',
            padding: '8px 14px', borderRadius: 8, cursor: 'pointer', fontWeight: 700, fontSize: 12
          }}>
            {f === 'todos' ? 'Todos' : f === 'bairro' ? 'Bairros' : 'Condomínios'}
          </button>
        ))}
      </div>

      {/* LISTAS */}
      {(filtro === 'todos' || filtro === 'bairro') && bairros.length > 0 && (
        <div style={{ marginBottom: 20 }}>
          <h3 style={{ fontSize: 13, color: 'var(--orange)', textTransform: 'uppercase', letterSpacing: .5 }}>
            🏘️ Bairros ({bairros.length})
          </h3>
          {bairros.map(renderItem)}
        </div>
      )}

      {(filtro === 'todos' || filtro === 'condominio') && condos.length > 0 && (
        <div>
          <h3 style={{ fontSize: 13, color: 'var(--orange)', textTransform: 'uppercase', letterSpacing: .5 }}>
            🏢 Condomínios ({condos.length})
          </h3>
          {condos.map(renderItem)}
        </div>
      )}

      {toast && (
        <div style={{
          position: 'fixed', bottom: 20, left: '50%', transform: 'translateX(-50%)',
          background: 'var(--bg3)', border: '1px solid var(--border)',
          padding: '10px 20px', borderRadius: 10, fontWeight: 700, zIndex: 1000
        }}>{toast}</div>
      )}
    </div>
  );
}
